import { Button } from '../../shared/ui/button';
import { DangerZone } from '../../shared/ui/danger-zone';
import { ErrorState, LoadingState } from '../../shared/ui/states';
import { isManager, type IActor, type TOrganization } from '../../entities/organization';
import { OrganizationDelete } from '../../features/organization-delete';
import { OrganizationProfile, useOrganizationProfile } from '../../features/organization-profile';
import { SettingsShell } from './settings-shell';
import { useOrganizationSettings } from './use-organization-settings';

const QUESTION = 'What this organization is called, and the address webhooks are sent to.';

const OrganizationScreen = ({
  organization,
  actor,
}: {
  organization: TOrganization;
  actor: IActor | null;
}) => {
  const profile = useOrganizationProfile(organization);
  const editable = isManager(actor);

  return (
    <SettingsShell
      active="/settings/organization"
      question={QUESTION}
      actions={
        editable && (
          <Button
            size="sm"
            disabled={!profile.canSave}
            waiting={profile.save.isPending}
            waitingLabel="Saving"
            onClick={() => profile.save.mutate()}
          >
            Save changes
          </Button>
        )
      }
    >
      <OrganizationProfile profile={profile} editable={editable} />
      <DangerZone>
        <OrganizationDelete organization={organization} owner={actor?.role === 'owner'} />
      </DangerZone>
    </SettingsShell>
  );
};

export const OrganizationSettingsPage = () => {
  const { organization, actor } = useOrganizationSettings();

  if (organization.data) {
    return (
      <OrganizationScreen
        key={organization.data.id}
        organization={organization.data}
        actor={actor}
      />
    );
  }

  return (
    <SettingsShell active="/settings/organization" question={QUESTION}>
      {organization.isError ? (
        <ErrorState error={organization.error} onRetry={() => void organization.refetch()} />
      ) : (
        <LoadingState rows={4} />
      )}
    </SettingsShell>
  );
};
